// http://stackoverflow.com/questions/3108986/gaussian-bankers-rounding-in-javascript
export default function bankersRound(number, decimalPlaces = 0) {
  const shiftProduct = Math.pow(10, decimalPlaces);
  const shifted = Number(decimalPlaces ? number * shiftProduct : number).toFixed(8); // Avoid rounding errors
  const numberAsInt = Math.floor(shifted);
  const fraction = shifted - numberAsInt;
  const rounded = fraction === 0.5 ? numberAsInt % 2 === 0 ? numberAsInt : numberAsInt + 1 : Math.round(shifted);
  if (decimalPlaces) {
    return rounded / shiftProduct;
  } else {
    return rounded;
  }
}